
import {
    get,
    post,
    del, getfile
} from '@/http/request'
import {
    HOST
} from '@/http/config'


// 新增专项资金自查
export function addSpecialFunds(params) {
    return post(`${HOST}special-funds/save`, params)
}
// 修改专项资金自查
export function updateSpecialFunds(params) {
    return post(`${HOST}special-funds/update`, params)
}
//专项资金自查列表
export function getSpecialFunds(params) {
    return get(`${HOST}special-funds/list`, params)
}
//专项资金自查草稿箱列表
export function SpecialFundsDraftlist(params) {
    return get(`${HOST}special-funds/draftlist`, params)
}
//专项资金自查详情
export function SpecialFundsDetial(params) {
    return get(`${HOST}special-funds/get`, params)
}
// 删除专项资金自查
export function delSpecialFunds(params) {
    return del(`${HOST}special-funds/delete`, params)
}
//统计查看
export function SpecialFundsStatistics(params) {
    return get(`${HOST}special-funds/statistics`, params)
}
// 导出模板
export function importTemplate() {
    return getfile(`${HOST}special-funds/importTemplate`)
}
// 导入专项资金自查Excel
export function importExcel(params) {
    return post(`${HOST}special-funds/importExcel`, params)
}







// WEBPACK FOOTER //
// ./src/views/SpecialFundsSelfInspection/api/api.js